import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import moment from 'moment';
import 'moment-timezone';

import { isMobileScreen } from '../actions/MobileAction';
import { toggleFeedbackPopupHidden } from '../actions/PopupActions';

import NXLogo from '../assets/images/header-coachTracker-small.svg';
import NXLogoRouteFinder from '../assets/images/header-nx-logo-route-finder.svg';
import NXLogoHorizontal from '../assets/images/NX_logo_horizontal.svg';
import BusEireannLogo from '../assets/images/bus-eireann/logo-bus-eireann.svg';
import DublinExpressLogo from '../assets/images/dublin-express/dublin-express-logo-header.svg';
import CityLogo from '../assets/images/citylink/logo.svg';
import MegabusLogo from '../assets/images/megabus/megabus-logo.svg';
import WCCELogo from '../assets/images/wcce/logo-WCCE.svg';
import HinkleyLogo from '../assets/images/hinkley/logo.svg';
import NXBusLogo from '../assets/images/nxbus/nxbus-logo.png';
import RCLogo from '../assets/images/regscoaches/RVS-logo.svg';
import TrailwaysLogo from '../assets/images/trailways/trailways-logo.svg';
import SuttonLogo from '../assets/images/suttonparkbus/logo.svg';
import HamburgerWebIcon from '../assets/images/hamburger-menu-web.svg';
import CloseIcon from '../assets/images/close-menu.svg';
import CloseMobileIcon from '../assets/images/close-menu-mobile.svg';
import HamburgerMobileIcon from '../assets/images/hamburger-menu-mobile.svg';
import CoachTrackerMenuItemIcon from '../assets/images/coachtracker-menu-item.svg';
import TimetableMenuItemIcon from '../assets/images/timetable-menu-item.svg';
import RouteFinderMenuItemIcon from '../assets/images/routefinder-menu-item.svg';
import SafetyToolboxMenuItemIcon from '../assets/images/safety-toolbox-menu-item.svg';
import FeedbackMenuItemIcon from '../assets/images/feedback-menu-item.svg';
import TicketsMenuItemIcon from '../assets/images/tickets-menu-item.svg';
import FacebookIcon from '../assets/images/social-icons/facebook.svg';
import TwitterIcon from '../assets/images/social-icons/x.svg';
import InstagramIcon from '../assets/images/social-icons/instagram.svg';
import LinkedinIcon from '../assets/images/social-icons/linkedin.svg';

import { THEME } from '../configs/global';

const getThemeLogo = (name, logoImage) => {
  switch (name) {
    case 'NX':
      switch (logoImage) {
        case 'coach-tracker':
          return NXLogo;
        case 'route-finder':
          return NXLogoRouteFinder;
        default:
          return NXLogo;
      }
    case 'Bus-Eireann':
      return BusEireannLogo;
    case 'Dublin-Express':
      return DublinExpressLogo;
    case 'Megabus':
      return MegabusLogo;
    case 'Regscoaches':
        return RCLogo;
    case 'Trailways':
        return TrailwaysLogo;
    case 'WCCE':
      return WCCELogo;
    case 'NX-Bus':
      return NXBusLogo;
    case 'Citylink':
      return CityLogo;
    case 'Hinkley':
      return HinkleyLogo;
    case 'Suttonparkbus':
      return SuttonLogo
    default:
      return NXLogo;
  }
};

const BookTicketURL = THEME.BOOKING_URL;
const ServiceURL =
  'https://book.nationalexpress.com/coach/#/campaign?journeyType=single&departArrive=DepartAfter&partnerId=uTrack&campaignId=default&returnDate=&departArriveReturn=DepartAfter&returnTime=';

class Header extends Component {
  static propTypes = {
    hideMap: PropTypes.func,
    clearSearch: PropTypes.func,
    index: PropTypes.bool,
    embed: PropTypes.bool,
  };

  constructor() {
    super();
    this.state = {
      isOpenHamburgerMenu: false,
    };

    this.headerMenuRef = React.createRef();
  }

  componentWillMount() {
    const timestamp = JSON.parse(localStorage.getItem('timestamp'));

    if (window.innerWidth <= 915 || (window.innerWidth <= 1000 && (window.orientation === 90 || window.orientation === 270))) {
      this.props.isMobileScreen({
        open: true,
      });
    }

    if (timestamp) {
      if (new Date().getTime() - timestamp > 172800000) {
        const keys = ['recentSearch', 'ticketSearch', 'timestamp'];
        for (let key of keys) {
          localStorage.removeItem(key);
        }
      }
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  navigateToIndex = (e) => {
    this.props.hideMap();
    this.props.clearSearch(true);
  };

  handleClickOutside = (event) => {
    const { isOpenHamburgerMenu } = this.state;

    if (
      isOpenHamburgerMenu &&
      this.headerMenuRef &&
      !this.headerMenuRef.current.contains(event.target)
    ) {
      this.setState({ isOpenHamburgerMenu: false });
    }
  };

  toggleHamburgerMenu = () => {
    this.setState((state) => {
      return {
        isOpenHamburgerMenu: !state.isOpenHamburgerMenu,
      };
    });
  };

  render() {
    const { isMobile, logoImage, bookTicketData, embed } = this.props;
    const { isOpenHamburgerMenu } = this.state;

    const today = moment(bookTicketData.time, 'YYYY-MM-DD HH:mm:ss Z').tz(
      'Europe/London'
    );
    const departureDate = today.format('DD/MM/YYYY');
    const departureTime = today.format('HH:mm');

    return (
      <header className="header">
        {!embed && <div className="header__container">
          <Link to="/" onClick={this.navigateToIndex}>
            <img src={getThemeLogo(THEME.NAME, logoImage)} alt={THEME.NAME} />
          </Link>
          <div className="header__container__rightside">
            {THEME.NAME === 'NX' &&
              !this.props.index && (
                <a
                  href={
                    bookTicketData && bookTicketData.time
                      ? `${ServiceURL}&departureDate=${departureDate}&outboundTime=${departureTime}&departureStopId=${
                          bookTicketData.request[0].bookingId
                        }&destinationStopId=${
                          bookTicketData.request[1].bookingId
                        }&${
                          bookTicketData.services[0].operatorId === 'OU'
                            ? 'ouiAdults=1'
                            : 'adults=1'
                        }`
                      : BookTicketURL
                  }
                  className="header__book"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Book Tickets
                </a>
              )}
            {THEME.NAME === 'Dublin-Express' && !this.props.index && (
              <a
                href={BookTicketURL}
                className="header__book"
                target="_blank"
                rel="noopener noreferrer"
              >
                Book Tickets
              </a>
            )}

            {(THEME.NAME === 'Megabus' || THEME.NAME === 'NX-Bus' || THEME.NAME === 'Citylink') && (
              <a
                href={BookTicketURL}
                className="header__book"
                target="_blank"
                rel="noopener noreferrer"
              >
                Book Tickets
              </a>
            )}
            {THEME.NAME === 'NX' &&
              <div className="header__menu__wrapper" ref={this.headerMenuRef}>
                  <img
                    onClick={this.toggleHamburgerMenu}
                    className="header__menu__icon"
                    src={
                      isOpenHamburgerMenu
                        ? isMobile
                          ? CloseMobileIcon
                          : CloseIcon
                        : isMobile
                        ? HamburgerMobileIcon
                        : HamburgerWebIcon
                    }
                    alt="Menu"
                  />

                <div
                  className={`header__menu__dropdown header__menu__dropdown--mobile ${
                    isOpenHamburgerMenu
                      ? 'header__menu__dropdown--mobile--open'
                      : 'header__menu__dropdown--mobile--close'
                  }`}
                >
                  <div className="header__menu__dropdown__title">
                    Select one of our products below:
                  </div>

                  <ul>
                    <li>
                      <NavLink
                        to="/"
                        onClick={() => {
                          this.navigateToIndex();
                          this.toggleHamburgerMenu();
                        }}
                        activeClassName="active"
                      >
                        <img src={CoachTrackerMenuItemIcon} alt={THEME.MAINTITLE ? THEME.MAINTITLE : "Coach Tracker"} />
                        <span>{THEME.MAINTITLE ? THEME.MAINTITLE : "Coach Tracker"}</span>
                      </NavLink>
                    </li>
                    <li>
                      <a
                        href="https://timetables.nationalexpress.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={TimetableMenuItemIcon} alt="Timetables" />
                        <span>Timetables</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://routemap.nationalexpress.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={RouteFinderMenuItemIcon} alt="Route Map" />
                        <span>Route Map</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.nationalexpress.com/en/help/safety"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={SafetyToolboxMenuItemIcon}
                          alt="Safety Information"
                        />
                        <span>Safety Information</span>
                      </a>
                    </li>
                    <li
                      onClick={() => {
                        this.toggleHamburgerMenu();
                        this.props.toggleFeedbackPopupHidden(false);
                      }}
                    >
                      <span className="nav-link">
                        <img src={FeedbackMenuItemIcon} alt="Feedback" />
                        <span>Feedback</span>
                      </span>
                    </li>
                    <li>
                      <a
                        href="https://book.nationalexpress.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={TicketsMenuItemIcon} alt="Book Tickets" />
                        <span>Book Tickets</span>
                      </a>
                    </li>
                  </ul>

                  <div className="header__menu__dropdown--mobile__footer">
                    <div className="header__menu__dropdown--mobile__footer__wrapper">
                      <div className="logo">
                        <img src={NXLogoHorizontal} alt="NX" />
                      </div>

                      <div className="social-links">
                        <a
                          href="https://www.facebook.com/NationalExpress"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src={FacebookIcon} alt="Facebook" />
                        </a>
                        <a
                          href="https://twitter.com/nationalexpress"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src={TwitterIcon} alt="Twitter" />
                        </a>
                        <a
                          href="https://www.instagram.com/nationalexpress"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src={InstagramIcon} alt="Instagram" />
                        </a>
                        <a
                          href="https://www.linkedin.com/company/national-express"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src={LinkedinIcon} alt="LinkedIn" />
                        </a>
                      </div>

                      <div className="link">
                        <a
                          href="https://www.nationalexpress.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          www.nationalexpress.com
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>}
        {THEME.NAME === 'NX' && THEME.SHOW_BANNER && (
          <div className="banner">
            <div className="banner--content">
              <span className="banner--content--bold">Please note: </span>
              <span>
                There is a temporary stop change for London Victoria Coach Station on Sunday 18 (A1 & A6 services only) & Monday 19 September. Tracking for services departing and arriving from London Victoria may be affected.
              </span>
              <span
                className="banner--content--link"
                onClick={() => {
                  window.open(
                    'https://www.nationalexpress.com/en/help/live-service-updates',
                    '_blank'
                  );
                }}
              >
                More Information.
              </span>
            </div>
          </div>
        )}
      </header>
    );
  }
}

const mapStateToProps = (state) => ({
  isMobile: state.mobileScreen.open,
  bookTicketData: state.services,
});

export default connect(mapStateToProps, {
  isMobileScreen,
  toggleFeedbackPopupHidden,
})(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js